<template>

  
 <div>
   <div v-if="showPayPalConformationBlur" :class="`loader-paypal`"></div>
   <div :class="`container-fluid ${showPayPalConformationBlur ?  `blur-updated-class` : null} ` ">

    
   
     <!-- <div class="loader-for-paypal"></div> -->
    <!-- TOP RED LINE -->
    <!-- <div class="row">
      <div class="col-12 mx-auto red-line py-2 px-0"></div>
    </div>-->

    <!-- BACK BUTTON -->
    <div class="row px-0 px-md-2 my-3 back-txt">
      <div class="col-5 col-md-6 align-self-center">
        <router-link to="/">
          <span class="mr-1">&#8249;</span>Go back to movie list
        </router-link>
      </div>

      <!-- <div class="col-6">
        <router-link class="float-right mt-2 gogo-text" to="">View Screening Detail<span class="ml-1">&#8250;</span>
        </router-link>
      </div>-->
      <div class="col-7 col-md-6 pr-3 pr-lg-4 align-self-center">
        <div class="timer-circle ml-auto mb-0">
          Time Remaining : &nbsp;
          <span>
            {{
              timer.minutes.toString().length == "1"
                ? "0" + timer.minutes
                : timer.minutes
            }}:{{
              timer.seconds.toString().length == "1"
                ? "0" + timer.seconds
                : timer.seconds
            }}</span
          >
        </div>
      </div>
    </div>

    <div class="verify-c">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
        hide-header-close
        ref="errorCard"
        id="errorCard"
        title="FAILED!"
      >
        <div class="p-5">
          <!-- <div class="text-center mb-3">
                      <img width="47" height="auto" src="@/assets/img/svg/tick-mark.svg">
          </div>-->
          <div class="text-center mt-3 mt-md-0">Sorry, {{ msgError }}</div>

          <b-button
            @click="hideModal"
            class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
            >Cancel
          </b-button>
        </div>
      </b-modal>
    </div>

    <div class="verify-c">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
        ref="sessionTimeOut"
        class="text-center"
        id="sessionTimeOut"
        title="HURRY UP!"
      >
        <div class="p-5">
          <!-- <div class="text-center mb-3">
                      <img width="47" height="auto" src="@/assets/img/svg/tick-mark.svg">
          </div>-->
          <div class="text-center mt-3 mt-md-0">
            Your booking has timed out!
          </div>
          <div class="text-center mt-3 mt-md-0">
            Click Here to restart the booking
          </div>
          <b-button
            v-on:click="$router.go(-1)"
            class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
            >Go Back
          </b-button>
        </div>
      </b-modal>
    </div>

    <div class="verify-c">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
        ref="apiKeyfailed"
        class="text-center"
        id="apiKeyfailed"
        title="Failed!"
      >
        <div class="p-5">
          <!-- <div class="text-center mb-3">
                      <img width="47" height="auto" src="@/assets/img/svg/tick-mark.svg">
          </div>-->
          <div class="text-center mt-3 mt-md-0">API key is invalid !</div>
          <div class="text-center mt-3 mt-md-0">
            Click Here to restart the booking
          </div>
          <b-button
            v-on:click="$router.go(-1)"
            class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
            >Go Back
          </b-button>
        </div>
      </b-modal>
    </div>

    <div class="verify-c">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
        ref="minimumPayment"
        class="text-center"
        id="minimumPayment"
        title="HURRY UP!"
      >
        <div class="p-5">
          <div class="text-center mt-3 mt-md-0">Sorry, the payment failed.</div>
          <div class="text-center mt-3 mt-md-0">
            Click Here to restart the booking
          </div>
          <b-button
            v-on:click="$router.go(-1)"
            class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
            >Go Back
          </b-button>
        </div>
      </b-modal>
    </div>

    <div class="col-12">
      <div class="row">
        <!-- TICKET START -->
        <div class="col-md-6 col-lg-3 h-75 mx-auto mb-4 px-0 mb-lg-2">
          <div class="cs-scr-ticket p-3 p-xl-3 mb-4">
            <div class="d-flex">
              <div
                class="col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"
              >
                <img v-lazy="showDetails.md_thumbnail_url" class="img-fluid" />
              </div>
              <div class="d-flex flex-column justify-content-between pl-3">
                <div>
                  <p class="mb-1">{{ showDetails.movie_title }}</p>
                  <ul class="list-inline movie-tickDetails">
                    <li class="list-inline-item">
                      {{ showDetails.mrrdr_runtime }}
                    </li>
                    <li class="list-inline-item">{{ showDetails.rating }}</li>
                    <li class="list-inline-item">
                      {{ showDetails.lang_name }}
                    </li>

                    <!-- <li class="list-inline-item">{{showDetails.Language}}</li>
                  <li class="list-inline-item">{{showDetails.Runtime}}</li>
                  <li class="list-inline-item">{{showDetails.Year}}</li>
                    <li class="list-inline-item">{{showDetails.ActorName}}</li>-->
                  </ul>
                </div>

                <div v-if="false">
                  <p class="rt-txt1">
                    <span class="d-block small">IMDB</span>
                    {{ showDetails.imdb_link }}
                  </p>
                  <p class="rt-txt2">
                    <span class="d-block small">Rating</span>
                    {{ showDetails.rating }}
                  </p>
                </div>
              </div>
            </div>
            <hr class="topLine my-2" />

            <!-- CINEMA NAME -->
            <div class>
              <small class="vCont">
                Cinema:
                <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
              </small>
              <p class="hCont">
                {{ showDetails.cine_name }}, &nbsp;
                {{ showDetails.cine_address }}
              </p>
              <small class="vCont">
                Screen:
                <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
              </small>
              <p class="hCont">{{ showDetails.screen_name }}</p>
            </div>

            <!-- DATE AND TIME -->
            <div class>
              <small class="vCont">
                Date &amp; Time:
                <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
              </small>
              <ul class="list-inline dateTime hCont">
                <li class="list-inline-item" v-if="checkKey == false">
                  {{ showDateHandlaler(showDetails.ss_start_date) }} |
                  {{ timeFormat(showDetails.ss_start_show_time) }}
                </li>
                <li class="list-inline-item" v-if="checkKey">
                  {{ showDetails.DateTime }}
                </li>
                <!-- <li class="list-inline-item">|</li> -->
                <!-- <li class="list-inline-item"></li> -->
              </ul>
            </div>

            <!-- SCREENING TYPE -->
            <div
              v-if="
                CategoryID === '2' ||
                  CategoryID === '4' ||
                  CategoryID == 2 ||
                  CategoryID === 4
              "
            >
              <small class="vCont">
                Screening Type:
                <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
              </small>
              <p class="hCont">{{ showDetails.booking_type_name }}</p>
            </div>

            <div
            
          >
            
            <p class="hCont">{{ showDetails.text_desc }}</p>
          </div>

            <!-- SELECTED SEATS -->
            <div v-if="ShowType != 'Private'" class>
              <small class="vCont">
                Pick Seats:
                <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
              </small>
              <ul class="list-inline seatList hCont">
                <li class="list-inline-item">
                  {{ showDetails.seat_name.replace("Hall", "Auditorium") }}
                </li>
                <!-- <li class="list-inline-item">L2</li>
              <li class="list-inline-item">L3</li>
                <li class="list-inline-item">L4</li>-->
              </ul>
            </div>

            <!-- TICKETS AND PROMO CODE DETAILS -->
            <div class="amount-box my-4">
              <div class="ticketAmount">
                <div class="d-flex justify-content-between">
                  <p>
                    Tickets
                    <span
                      >({{
                        this.CategoryID == 2
                          ? showDetails.booking_type_id == 3
                            ? showDetails.screen_no_of_seats
                            : showDetails.ticket_count
                          : showDetails.ticket_count
                      }}</span
                    >) :
                  </p>
                  <p>
                    {{ curr_code }} {{ currFormat(showDetails.net_amount) }}
                  </p>
                </div>

                <!-- Added by Yogesh@2019-09-10 | @Description => To show the service tax -->
                <div
                  class=""
                  v-if="
                    showDetails.chargeTypeArray &&
                      showDetails.chargeTypeArray.length > 0
                  "
                >
                  <div
                    class="d-flex justify-content-between"
                    v-for="(charge, chargeIndex) in [...showDetails.chargeTypeArray].reverse()"
                    :key="chargeIndex"
                  >
                    <p>{{ charge.ct_name }} :</p>
                    <p>
                      {{ curr_code }}
                      {{ currFormat(charge.tax_amount) }}
                    </p>
                  </div>
                </div>
                <!-- Added by Yogesh@2019-09-10 | @Description => To show the service tax -->

                <div v-if="promoApplied" class="d-flex justify-content-between">
                  <div>
                    <p class="mb-0">
                      Promocode Discount :
                      <!-- <router-link to="#">(Change)</router-link> -->
                    </p>
                    <small class="text-muted">{{ promocode }}</small>
                  </div>
                  <p class="text-success">
                    <span>-</span>  
                    {{ curr_code }} {{ currFormat(DiscountValue) }}
                  </p>
                </div>

                <hr class="bottomLine my-4" id="totalPayment" />
              </div>

              <div class="d-flex justify-content-between">
                <div>
                  <p class="mb-0 vCont">
                    Total Amount Payable :
                    <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
                  </p>

                  <!-- Added by Yogesh@2019-09-10 | @Description => To show the service tax -->
                </div>
                <p class="hCont">
                  {{ curr_code }} {{ currFormat(totalPayableAmount) }}
                </p>
              </div>
              <div>
                <small class="vCont"
                  >(Amount inclusive of all service fees and taxes)</small
                >
              </div>
            </div>

            <!-- PROMO CODE -->
            <div class="promoCode-box" v-if="showCoupon">
              <p class="vCont">
                Apply Promo Code:
                <!-- <router-link to="#" class="float-right pt-1 vCont">(View All Offers)</router-link> -->
              </p>
              <b-input-group>
                <b-form-input
                  type="text"
                  class="promo-code-text"
                  v-model="promocode"
                  placeholder="Apply Your Promo Code"
                />
                <b-input-group-append>
                  <b-button
                    variant="default"
                    @click="onApplyPromocode()"
                    class="promo-btn"
                    >APPLY</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <small class="mt-2 text-danger">{{
                this.promocodeErrorMessage
              }}</small>
              <small class="mt-2 text-success">{{
                this.promocodeSuccesMessage
              }}</small>
            </div>
          </div>
          <!-- <div class="mx-auto my-4 text-center pro-circle">
            <progressRing />
          </div>-->
        </div>
        <!-- TICKET END -->

        <div class="col-md-12 col-lg-9 px-0 px-lg-3 mb-5 mb-md-0">
          <div role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header
                v-on:click="tabs.collapse1 = !tabs.collapse1"
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    v-b-toggle.accordion1
                    variant="default"
                    class="py-md-3 cus-btn"
                    :class="
                      Object.values(bookingDetails).length == 0 &&
                      tabs.collapse1
                        ? 'active'
                        : ''
                    "
                  >
                    1. Contact Information
                    <img
                      v-if="Object.values(bookingDetails).length > 0"
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />
                    <span v-if="!tabs.collapse1" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-if="tabs.collapse1" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="col-12 p-0 p-md-3">
                    <div class="row">
                      <!-- USER LOGIN -->
                      <div
                        v-if="userInfo || userLoggedIn"
                        class="col-md-6 mx-auto login-box"
                      >
                        <div class="mob-login-box pr-md-5">
                          <b-form data-vv-scope="verifyUserDetails">
                            <b-input
                              v-validate="'required'"
                              v-model="userDetails.email"
                              class="mt-1 mr-sm-2 pc-input"
                              id="inlineFormInputName22"
                              placeholder="Enter your Email Address"
                            />
                            <!-- <b-input name="mobile1" v-model="userDetails.MobileNo" class="mb-2 mt-3 mr-sm-2 pc-input" id="inlineFormInputName3" placeholder="Enter your Mobile Number" /> -->
                            <!-- <vue-tel-input :defaultCountry="userDetails.PhoneCode" id="phone" v-model="userDetails.MobileNo" v-validate="'required'" name="phonenumber" class="mb-2 mt-1 mr-sm-2 pc-input form-control" placeholder="Enter Your Mobile Number" @onInput="onUserInput"></vue-tel-input>
                            -->
                            <div class="row align-items-center mt-3">
                              <div class="col-3 pr-0 pr-xl-2 country-code-drop">
                                <b-dropdown
                                  v-if="CountryCodeList.length > 0"
                                  class="pc-input form-control"
                                  :text="userDetails.country_mob_code || 'Code'"
                                  variant="default"
                                  slot="append"
                                >
                                  <div class="px-2 pb-2">
                                    <input
                                      required
                                      autofocus
                                      type="search"
                                      placeholder="Search Code"
                                      class="form-control form-control-sm"
                                      v-on:keyup="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:keydown="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:search="
                                        onSearchCode($event.target.value)
                                      "
                                      v-model="searchCode"
                                    />
                                  </div>
                                  <b-dropdown-item
                                    class
                                    v-on:click="onChangeCountry(country)"
                                    v-for="(country,
                                    countryIndex) in CountryCodeList"
                                    :key="countryIndex"
                                    >{{ country.country_mob_code }} &nbsp;
                                    {{ country.country_name }}</b-dropdown-item
                                  >
                                </b-dropdown>
                              </div>

                              <div class="col-9">
                                <b-input
                                  name="phonenumber"
                                  type="number"
                                  class="mr-sm-2 pc-input"
                                  v-validate="'required'"
                                  v-model="userDetails.phone_no"
                                  id="inlineFormInputName10"
                                  placeholder="Enter Your Phone Number"
                                />
                              </div>
                              <div
                                v-show="
                                  errors.has('verifyUserDetails.phonenumber')
                                "
                                class="text-danger text-center my-2 pl-3"
                              >
                                {{
                                  errors.first("verifyUserDetails.phonenumber")
                                }}
                              </div>
                            </div>
                            <!-- Italic & grey -->
                            <div class="small text-muted mt-2">
                              * Tickets will be sent to the above contact
                              details
                            </div>

                            <div class="mt-2">
                              <b-button
                                @click="
                                  validateBeforeSubmit('verifyUserDetails')
                                "
                                class="gogo-btn btn btn-danger"
                              >
                                Confirm Your Details
                              </b-button>
                              <!-- <input type="submit" value="Confirm your Details"> -->
                            </div>
                          </b-form>
                        </div>
                        <!-- <b-button class="mt-3 mt-md-5 ml-md-2 nm-btn px-3 px-md-5">Proceed</b-button>                        -->
                      </div>
                      <!-- USER LOGIN END -->

                      <!-- <div class="col-12 text-center mt-4 mb-3 d-md-none"><img src="@/assets/img/svg/SeparatorOR.svg" class="img-fluid"></div> -->
                      <div
                        v-if="ShowSignUp && !userLoggedIn"
                        class="col-md-6 mx-auto loginmodal"
                      >
                        <p v-if="!userInfo && !ShowLogin" class="mb-2 log-text">
                          Sign Up
                        </p>
                        <!-- SIGNUP USER -->
                        <b-form
                          v-if="!userInfo && !ShowLogin"
                          @submit.prevent="validateBeforeSubmit('signUp')"
                          data-vv-scope="signUp"
                          name="signUpForm"
                        >
                          <div class="mob-login-box">
                            <b-input
                              autocomplete="false"
                              name="email"
                              type="email"
                              class="mt-1 mr-sm-2 pc-input"
                              v-validate="'required|email'"
                              v-model="signUpUserDetails.email"
                              id="inlineFormInputNameemail2"
                              placeholder="Enter Your Email Address"
                            />
                            <div
                              v-show="errors.has('signUp.email')"
                              class="py-1 text-danger font-weight-bold small"
                            >
                              {{ errors.first("signUp.email") }}
                            </div>
                            <!-- <vue-tel-input v-model="phone" v-validate="'required'" name="phonenumber"
                              class="mt-3 mr-sm-2 pc-input form-control" placeholder="Enter Your Mobile Number"
                            @onInput="onInput"></vue-tel-input>-->
                            <div class="row align-items-center mt-3">
                              <div class="col-3 pr-0 pr-xl-2 country-code-drop">
                                <b-dropdown
                                  v-if="CountryCodeList.length > 0"
                                  class="pc-input form-control"
                                  :text="
                                    signUpUserDetails.country_mob_code || 'Code'
                                  "
                                  variant="default"
                                  slot="append"
                                >
                                  <div class="px-2 pb-2">
                                    <input
                                      type="search"
                                      placeholder="Search Code"
                                      class="form-control form-control-sm"
                                      name="countryCode"
                                      v-on:keyup="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:keydown="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:search="
                                        onSearchCode($event.target.value)
                                      "
                                      v-model="searchCode"
                                    />
                                  </div>
                                  <b-dropdown-item
                                    class
                                    v-on:click="onChangeCountry(country)"
                                    v-for="(country,
                                    countryIndex) in CountryCodeList"
                                    :key="countryIndex"
                                    >{{ country.country_mob_code }}&nbsp;
                                    {{ country.country_name }}</b-dropdown-item
                                  >
                                </b-dropdown>
                              </div>

                              <div class="col-9">
                                <b-input
                                  name="phonenumber"
                                  type="number"
                                  :min="0"
                                  class="mr-sm-2 pc-input"
                                  v-validate="'required|min:8|max:12'"
                                  v-model="signUpUserDetails.phoneNumber"
                                  id="inlineFormInputName11"
                                  placeholder="Enter Your Phone Number"
                                />
                                <div
                                  v-show="
                                    errors.has('signUpUserDetails.phonenumber')
                                  "
                                  class="text-danger text-center my-2"
                                >
                                  {{
                                    errors.first(
                                      "signUpUserDetails.phonenumber"
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <div
                              v-show="errors.has('signUp.phonenumber')"
                              class="py-1 text-danger font-weight-bold small"
                            >
                              {{ errors.first("signUp.phonenumber") }}
                            </div>
                            <b-input
                              type="password"
                              name="password"
                              class="mt-3 mr-sm-2 pc-input"
                              v-validate="{
                                required: 'required',
                                regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/
                              }"
                              v-model="signUpUserDetails.password"
                              id="inlineFormInputNamepassword"
                              placeholder="Enter Your Password"
                            />
                            <div
                              v-show="errors.has('signUp.password')"
                              class="py-1 text-danger font-weight-bold small"
                            >
                              {{
                                !signUpUserDetails.password
                                  ? passwordRequiredMessage
                                  : passwordValidationMessage
                              }}
                              <!-- {{ errors.first("signUp.password") }} -->
                            </div>
                          </div>
                          <b-form-checkbox
                            class="grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2"
                            id="checkbox-tandc"
                            v-model="signUpUserDetails.termsAndConditions"
                            name="checkbox-tandc"
                            value="accepted"
                            unchecked-value="not_accepted"
                          >
                            I agree to all
                            <router-link
                              to="/termsCondition"
                              class="tnc-class"
                              target="_blank"
                              >Terms &amp; Conditions
                            </router-link>
                          </b-form-checkbox>
                          <div
                            v-on:click="onClickLogin()"
                            class="small text-muted mt-2 cursor-pointer"
                          >
                            Already have an account? Click here to
                            <u>
                              <b>Sign In</b>
                            </u>
                          </div>
                          <div class="py-2 text-danger font-weight-bold small">
                            {{ errorMessage.signUp }}
                          </div>
                          <input
                            type="submit"
                            name="submitBtn"
                            class="btn btn-danger gogo-btn mt-2"
                            value="Create an account"
                          />
                        </b-form>
                        <!-- SIGNUP USER ENDS -->
                      </div>

                      <!-- LOGIN USER -->
                      <div
                        v-else-if="ShowLogin && !userLoggedIn"
                        class="col-md-6 mb-5 mb-md-0 mx-auto login-box"
                      >
                        <p class="log-text mb-2">LOGIN</p>
                        <div class="mob-login-box pr-md-5">
                          <b-form data-vv-scope="UserSignIn">
                            <b-input
                              v-validate="'required|email'"
                              type="email"
                              v-model="userDetails.email"
                              class="mt-1 mr-sm-2 pc-input"
                              id="inlineFormInputName4"
                              placeholder="Enter Your Email Address"
                            />
                            <b-input
                              v-validate="'required'"
                              type="password"
                              v-model="userDetails.password"
                              class="mt-3 mr-sm-2 pc-input"
                              id="inlineFormInputName5"
                              placeholder="Enter Your Password"
                            />
                            <div
                              class="py-2 text-danger font-weight-bold small"
                            >
                              {{ errorMessage.login }}
                            </div>
                            <div
                              v-on:click="onClickForgotPassword()"
                              class="small text-muted mb-2 cursor-pointer"
                            >
                              Forgot Password?
                            </div>
                            <div
                              v-on:click="onClickSignUp()"
                              class="small text-muted mt-2 cursor-pointer"
                            >
                              Do not have an account? Click here to
                              <u>
                                <b>Sign Up</b>
                              </u>
                            </div>

                            <div>
                              <b-button
                                @click="validateBeforeSubmit('UserSignIn')"
                                class="my-2 btn btn-danger gogo-btn"
                                >Login</b-button
                              >
                            </div>
                          </b-form>
                        </div>
                      </div>
                      <!-- LOGIN USER ENDS -->
                    </div>
                  </div>
                  <div class="col-12 px-0 d-none">
                    <div class="text-success font-weight-bold d-md-flex">
                      <!-- <div class="pr-md-4"><img class="d-block mx-auto" width="47" height="auto" src="@/assets/img/svg/tickmark.svg"></div> -->
                      <div class="text-mob mt-3 mt-md-0">
                        Awesome! Your verification is complete and your account
                        has been created! You’ll get a link to reset your
                        password which you can do later if you’d like as well.
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 px-0 px-md-2">
                      <b-button v-if="showProceedForLogin" v-b-toggle.accordion2 v-on:click="getReserveBookinId()" class="mt-4 pc-mob nm-btn px-5">Proceed</b-button>
                  </div>-->
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1" id="PaymentShow">
              <b-card-header
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <!-- v-b-toggle.accordion2  -->
                  <b-button
                    href="#"
                    block
                    variant="default"
                    class="py-md-3"
                    v-bind:class="[
                      Object.values(bookingDetails).length == 0
                        ? 'disabled'
                        : tabs.collapse2
                        ? 'active'
                        : ''
                    ]"
                  >
                    2. Payment Mode
                    <img
                      v-if="showProceedButton"
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />

                    <span v-if="!tabs.collapse2" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-if="tabs.collapse2" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
                 
              </b-card-header>
              <b-collapse
                id="accordion2"
                accordion="my-accordion"
                role="tabpanel"
              >

                <!-- <b-button @click="EditPaymentMode()" v-if="(is_branin_tree_active || is_paypal_active && !slect_payment_mode)">Edit</b-button> -->

                <!-- showBrainTreeContainer -->
                <b-card-body v-if="directPay">
                  <div id="dropin-container"></div>
                  <b-button
                    ref="submitButton"
                    class="btn py-md-2 px-md-5 btn-danger"
                    id="submit-button"
                    @click="payNow()"
                    >PAY
                    {{ curr_code }}
                    {{ currFormat(totalPayableAmount) }}</b-button
                  >
                </b-card-body>

                
                <b-card-body v-else-if="isBrainTreeActive && bt_client_token && !slect_payment_mode && is_branin_tree_active">
                  <div id="dropin-container">
                    <v-braintree
                      :authorization="bt_client_token"
                      :btnText="
                        `Pay ${curr_code} ${currFormat(totalPayableAmount)}`
                      "
                      :btnClass="`btn btn-danger`"
                      @load="onLoad"
                      @loadFail="onLoadFail"
                      @success="bt_makePayment"
                      @error="onError"
                      :vaultManager="true"
                    ></v-braintree>
                  </div>
                </b-card-body>
                <b-card-body v-else-if="!PaymentOptionsLoading && !slect_payment_mode && is_branin_tree_active">
                  <div
                    id="no-payment-modes"
                    class="w-100 text-center mt-5 text-muted"
                  >
                    <p>No Active Payment Modes. Contact Support Team</p>
                    <router-link
                      class="mt-3 btn btn-danger text-light"
                      :to="{
                        name: 'Home'
                      }"
                      >Home</router-link
                    >
                  </div>
                </b-card-body>

                 <b-button
                    ref="submitButton"
                    class="btn btn-danger btn py-md-2 px-md-5 m-2 btn-danger"
                    id="submit-button"
                    @click="paypal_makePayment()"
                    >Pay
                    {{ curr_code }}
                    {{ currFormat(totalPayableAmount) }}</b-button
                  >

                  <!-- <div class="d-flex justify-content-center">
                      <b-button
                      class="mx-1"
                v-if="slect_payment_mode && this.showDetails.cine_id == 1"
                    @click="slectPaymentMode('brain_tree')"
                    >Brain Tree
                  </b-button
                  >
                    <b-button
                 v-if="slect_payment_mode && this.showDetails.cine_id == 2"
                    class="mx-1"
                    @click="slectPaymentMode('paypal')"
                    >PayPal
                    </b-button
                  >
                  </div>  -->
              </b-collapse>

               <!-- <b-collapse
                id="accordion2"
                accordion="my-accordion"
                role="tabpanel"
              > 
                  <b-button
                    ref="submitButton"
                    class="btn btn-danger btn py-md-2 px-md-5 btn-danger"
                    id="submit-button"
                    @click="paypal_makePayment()"
                    >PAY With Paypal
                    {{ curr_code }}
                    {{ currFormat(totalPayableAmount) }}</b-button
                  >

               </b-collapse> -->
              
            </b-card>
            <b-card no-body class="d-none mb-1">
              <b-card-header
                v-on:click="tabs.collapse3 = !tabs.collapse3"
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    variant="default"
                    class="py-md-3"
                    v-bind:class="[
                      tabs.collapse3 && showProceedButton
                        ? 'active'
                        : showProceedButton
                        ? ''
                        : 'disabled'
                    ]"
                  >
                    3. Confirmation
                    <span
                      v-if="!tabs.collapse3 && !showProceedButton"
                      class="check-markIcon"
                    >
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span
                      v-else-if="tabs.collapse3 && showProceedButton"
                      class="check-markIcon"
                    >
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-else-if="tabs.collapse3" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div
                    class="col-sm-4 px-0 px-md-3 mb-3 col-lg-4 mx-auto text-center"
                  >
                    <router-link
                      v-if="confirmDetails"
                      :to="{
                        name: 'confirmScreen',
                        params: {
                          bookingId: confirmDetails.BookingID || 0,
                          paymentId: PaymentId || 2
                        }
                      }"
                    >
                      <b-button
                        v-if="showProceedButton"
                        class="gogo-btn btn btn-danger"
                        >Confirm</b-button
                      >
                    </router-link>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <!-- <div class="col-12 col-md-9 col-xl-6 text-center mx-auto mt-5">
            <div class="d-flex flex-column justify-content-between">
              <div class="mb-4">
                <img src="@/assets/img/svg/icons-movie.svg" claas="img-fluid">
                <p class="at-text pt-3">Almost there! Just one last thing before <br> your screening is created!</p>
              </div>
              <div>
                <img src="@/assets/img/svg/bg-gogo.svg" class="img-fluid">
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      ref="SeatRealeased"
      class="text-center"
      id="minimumPayment"
      title="FAILED !"
    >
      <div class="p-5">
        <div class="text-center mt-3 mt-md-0">{{ showMessage }}</div>
        <b-button
          v-on:click="hideModal"
          class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
          >Go Back</b-button
        >
      </div>
    </b-modal>
  </div>
 </div>
</template>

<script>
import Slick from "vue-slick";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import { makeRequest } from "@/helper/internet.js";
import { countryArray } from "@/helper/collection.js";
import { URL_BASE, STRIPE_PUBLIC_KEY } from "@/helper/constants.js";
import { TokenService } from "@/services/storage.service";
import $ from "jquery";
import EventBus from "@/eventBus.js";
import progressRing from "@/components/partials/progressRing.vue";
import moment from "moment";
import _ from "lodash";

var STRIPEPUBLICKEY;
if (
  window.localStorage.getItem("country") != "" &&
  window.localStorage.getItem("country") != null &&
  window.localStorage.getItem("country") != undefined &&
  JSON.parse(window.localStorage.getItem("country")).hasOwnProperty("pgData")
) {
  if (
    JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey != ""
  ) {
    STRIPEPUBLICKEY = JSON.parse(window.localStorage.getItem("country"))
      .pgData[0].PublicKey;
  } else {
    STRIPEPUBLICKEY = STRIPE_PUBLIC_KEY;
  }
} else {
  STRIPEPUBLICKEY = STRIPE_PUBLIC_KEY;
}

console.log(STRIPEPUBLICKEY, "keyp");

var stripe = Stripe(STRIPEPUBLICKEY);
var VueScrollTo = require("vue-scrollto");
import {
  Card,
  createToken,
  createPaymentMethod,
  handleCardPayment,
  handleCardAction
} from "vue-stripe-elements-plus";
import { CardNumber, CardExpiry, CardCvc } from "vue-stripe-elements-plus";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import PromotionServices from "@/services/PromotionServices.js";
import debounce from "debounce";

export default {
  name: "payment",
  props: ["stripe", "options"],
  components: {
    Slick,
    DatePick,
    progressRing,
    Card,
    CardNumber,
    CardExpiry,
    CardCvc
  },

  data() {
    return {
      showPayPalConformationBlur : false,
      showCoupon: true,
      msgError: "",
      stripePublicKey: STRIPEPUBLICKEY,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      instance: null,
      isPayLoading: false,
      PaymentOptionsLoading: false,
      cientToken:
        "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",
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      BASEURL: URL_BASE,
      phone: "",
      MobileNo: "",
      promoApplied: false,
      statusFlag: {
        paymentActive: ""
      },
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 10,
        seconds: 0,
        stop: false
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id:
          "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      tabs: {
        collapse1: true,
        collapse2: false,
        collapse3: false
      },
      UserToken: false,
      userLoggedIn: false,
      ShowLogin: true,
      showDetails: {},
      movieDetails: {},
      bookingDetails: {},
      CinemaScheduleID: "",
      CategoryID: "",
      BookSeats: "",
      BookingSeatsName: "",
      ShowType: "",
      nonce: "",
      ReserveId: "",
      Successurl: "",
      Failurl: "",
      bookID: "",
      PaymentId: "",
      userDetails: {
        email: "",
        phone_no: "",
        password: "",
        CountryCode: "1",
        country_id: 38,
        country_mob_code: "1"
      },
      signUpUserDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_mob_code: "1",
        country_id: 38
      },
      OTP: ["", "", "", ""],
      errorMessage: {
        login: "",
        signUp: "",
        reserveBooking: "",
        payment: "",
        socialLoginError: ""
      },
      OGtotalAmount: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      paymentToken: "",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      checkKey: false,
      paymetOptions: {},
      showOtpSection: false,
      showBrainTreeContainer: false,
      showProceedForLogin: false,
      showProceedButton: false,
      ScreeningTypeName: "",
      selected: true,
      confirmDetails: {},
      promocode: "",
      DiscountValue: 0,
      TaxOfferValue: 0,
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      CountryCodeList: [],
      paymentSecret: "",
      stripeCards: [],
      stripeCardSelected: {},
      selectedPaymentOptionID: "",
      ReservationID: null,
      offerData: {},
      directPay: false,
      showMessage: "",
      searchCode: "",
      countriesCopy: [],
      ActivePaymentModes: [],
      isBrainTreeActive: false,
      slect_payment_mode : true,
      is_branin_tree_active: false,
      is_paypal_active : true,
      bt_client_token: null,
      braintree_customerid:"",
      userInfo: null,
      ShowSignUp: false,
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage:
        "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number"
    };
  },
  mounted() {
    EventBus.$on("onSignUpError", message => {
      this.errorMessage.signUp = message;
    });
    EventBus.$on("onSignUpSuccess", () => {
      this.ShowLogin = true;
      this.ShowSignUp = false;
    });
    EventBus.$on("onProfileSuccess", () => {
      this.fetchUserDetails();
    });
    // Create an instance of Elements.
    var elements = stripe.elements();
    // import { StripeElement } from
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    if (window.innerWidth <= 991) {
      setTimeout(function() {
        VueScrollTo.scrollTo("#totalPayment", "1000");
      }, 1000);
    }

    // var stripe = Stripe('pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

    // Create an instance of the card Element.
    // var card = elements.create("card", { style: style });

    // // Add an instance of the card Element into the `card-element` <div>.
    // card.mount("#card-element");

    // // Handle real-time validation errors from the card Element.
    // card.addEventListener("change", function(event) {
    //   var displayError = document.getElementById("card-errors");
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //   } else {
    //     displayError.textContent = "";
    //   }
    // });

    // // Handle form submission.
    // var form = document.getElementById("payment-form");
    // form.addEventListener("submit", function(event) {
    //   event.preventDefault();

    //   stripe.createToken(card).then(function(result) {
    //     if (result.error) {
    //       // Inform the user if there was an error.
    //       var errorElement = document.getElementById("card-errors");
    //       errorElement.textContent = result.error.message;
    //     } else {
    //       // Send the token to your server.
    //       stripeTokenHandler(result.token);
    //     }
    //   });
    // });

    // // Submit the form with the token ID.
    // function stripeTokenHandler(token) {
    //   // Insert the token ID into the form so it gets submitted to the server
    //   var form = document.getElementById("payment-form");
    //   var hiddenInput = document.createElement("input");
    //   hiddenInput.setAttribute("type", "hidden");
    //   hiddenInput.setAttribute("name", "stripeToken");
    //   hiddenInput.setAttribute("value", token.id);
    //   form.appendChild(hiddenInput);

    //   // Submit the form
    //   form.submit();
    // }
  },
  beforeMount() {

    // this.isPayLoading = true;
      // this.showLoading();

      

if(this.$route.query.paymentId && this.$route.query.PayerID){
      

  this.showPayPalConformationBlur = true
  //  this.showLoading();
  

     MainServices.ExecutePaymentWithPaypal({
      payment_id :  this.$route.query.paymentId,
      payer_id : this.$route.query.PayerID
     })
        .then(response => {
        //  console.log(response,  "success >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        // this.isPayLoading = false
        // this.hideLoading();
        if(response.data && response.data.status  ==  "success"){
            this.payNow("paypal")
        }else{
           this.$router.push({
            name: "failedPayment"
          });
        }
       
        //  window.location.href = response.data.payment_url
        })
        .catch(err => {
          console.log("Error:", err);
          this.$router.push({
            name: "failedPayment"
          });
        })
        .finally(() => {
          // this.isPayLoading = false;
          // this.hideLoading();
        });
      
    }
      

  
    this.ReservationID = this.$route.params.reservation_id || null;
    this.CategoryID = this.$route.params.category_id || 1;
    this.userInfo = window.localStorage.getItem("user")
      ? JSON.parse(window.localStorage.getItem("user"))
      : null;
    console.log(this.$route.params);
    if (this.CategoryID == 2) {
      this.getCreateReservation();
    } else {
      this.getReservationDetails();
    }
    this.fetchUserDetails();
    this.getAllGetCountryList();
    this.getActivePaymentModes();
    this.checkUserLogin();


      

  },
  watch: {
    number() {
      this.update();
    },
    expiry() {
      this.update();
    },
    cvc() {
      this.update();
    }
  },
  computed: {
    payBtnText() {
      return `Pay ${curr_code} ${currFormat(totalPayableAmount)}`;
    },
    totalPayableAmount() {
      let total = this.showDetails.amount - this.DiscountValue - this.TaxOfferValue;
      return total;
    },
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    _userInfo() {
      if (window.localStorage.getItem("user")) {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  methods: {

     showDateHandlaler(date) {
     return moment(date).format("MMMM DD, YYYY")
    },

  payNowWithPaypal() {
      MainServices.MakePaymentWithPaypal()
        .then(response => {
         console.log(response,  "success >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")

         window.location.href = response.data.payment_url
        })
        .catch(err => {
          console.log("Error:", err);
          this.$router.push({
            name: "failedPayment"
          });
        })
        .finally(() => {
          this.isPayLoading = false;
        });
    },

    checkUserLogin() {
      if (window.localStorage.getItem("user")) {
        this.userLoggedIn = true;
      }
    },
    onLoad(instance) {
      this.instance = instance;
    },
    onLoadFail(instance) {
      this.showMessage = "Something Went Wrong!";
      this.$refs.SeatRealeased.show();
    },
    bt_makePayment(payload) {
      this.isPayLoading = true;
      // this.showLoading();
      console.log("Success!", payload.nonce);

      payload = {
        nounce: payload.nonce,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid:this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code,
        category_id: this.CategoryID,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isCinema: this.CategoryID == 2
      };
      MainServices.MakePayment(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.payNow();
          } else {
            this.showMessage = data.message;
            // this.hideLoading();
            this.$refs.SeatRealeased.show();
          }
        })
        .catch(err => {
          console.log("Error:", err);
          this.$router.push({
            name: "failedPayment"
          });
        })
        .finally(() => {
          this.isPayLoading = false;
        });
    },
  EditPaymentMode(payload){
    this.slect_payment_mode = true
  },
    slectPaymentMode(payload){
      this.slect_payment_mode = false
      if(payload ==  "paypal"){
        this.is_paypal_active = true
      }else {
        this.is_branin_tree_active = true
      }
      // console.log(payload, "payload >>>>>>>>>>>>>>>>>>")
    },

    paypal_makePayment(payload) {

      // console.log(window.location.hostname, "inside >>>>>>>>>>>>>")

      this.isPayLoading = true;
      // this.showLoading();
      // console.log("Success!", payload.nonce);

      console.log(window.location.hostname, "window.location.hostname >>>>>>>>>>>>>")

      payload = {
        // nounce: payload.nonce,
        category_id :  this.CategoryID,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid:this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code,
        category_id: this.CategoryID,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isCinema: this.CategoryID == 2,
        host : window.location.hostname
      };
      MainServices.MakePaymentWithPaypal(payload)
        .then(response => {
          const { data } = response;
          // console.log(response, "response >>>>>>>>>>>>>>>>>>>>")
          if (data.status) {
            // this.payNow();
             window.location.href = response.data.payment_url
          } else {
            this.showMessage = data.message;
            // this.hideLoading();
            this.$refs.SeatRealeased.show();
          }
        })
        .catch(err => {
          console.log("Error:", err);
          this.$router.push({
            name: "failedPayment"
          });
        })
        .finally(() => {
          this.isPayLoading = false;
        });
    },
    onError(error) {
      console.log("Error!", error);
    },
    getActivePaymentModes() {
      MainServices.GetActivePaymentModes(2)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.ActivePaymentModes = data.Records;
          } else {
            console.log("Error:", data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    checkPaymentMode(paymentModes) {
      this.PaymentOptionsLoading = true;
      // this.showLoading();
      let BrainTree = paymentModes.find(x => x.pm_id == 16);
      if (BrainTree) {
        this.isBrainTreeActive = true;
        console.log("this.userInfo checkPaymentMode", this.userInfo);
        MainServices.createBrainTreeClientToken({
          cust_id: this.userInfo.cust_id
        })
          .then(response => {
            const { data } = response;
            if (data.status) {
              this.bt_client_token = data.clientToken;
              this.braintree_customerid = data.braintree_customerid;
            } else {
              console.log("Error: ", data.message);
            }
          })
          .catch(err => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.PaymentOptionsLoading = false;
            // this.hideLoading();
          });
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          } else if (
            x.country_name &&
            x.country_name.toLowerCase().includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    GetDate(date, format) {
      if (format == "day") {
        return moment(date).format("ddd");
      } else if (format == "time") {
        return moment(date).format("HH:mm");
      } else if (format == "month") {
        return moment(date).format("mmm");
      } else if (format == "date") {
        return moment(date).format("dd");
      } else if (format == "full") {
        return moment(date).format("ll");
      }
    },
    selectPayment(Payment) {
      this.PaymentId = Payment.PaymentID;
      this.onSelectPayment(Payment);
    },
    proceedStripePayment() {
      this.selectedPaymentOptionID = 3;
    },
    confirmStripePaymentDetails() {
      this.timer.stop = true;

      if (this.stripeCardSelected.id) {
        // this.useAlreadyPresentCard();
        var cardButton = document.getElementById("card-button");
        console.log("test1", this.paymentSecret);

        // cardButton.addEventListener('click', function(ev) {
        //     // console.log('test2', this.paymentSecret)

        //     // stripe.handleCardPayment(
        //     //     this.paymentSecret, {
        //     //         payment_method:'pm_1FMeCsHnQVOfChkcPTGI8tAT',
        //     //     }
        //     // ).then(function(result) {
        //     //     if (result.error) {
        //     //         // Display error.message in your UI.
        //     //     } else {
        //     //         // The payment has succeeded. Display a success message.
        //     //     }
        //     // });
        // });
      } else {
        this.startStripeWithoutSavedCard();
      }
    },

    updatePaymentMethod(paymentMethodID) {
      let payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        PaymentMethod: paymentMethodID,
        updateCustomer: true,
        gogoStripe: 1
      };
      console.log("paymentMethodID :", paymentMethodID);
      makeRequest("/getPGOptions/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log("res payment1:", res);
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    useAlreadyPresentCard() {
      let payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        payment_method_id: this.stripeCardSelected.id,
        gogoStripe: 1
      };
      // this.showLoading();
      makeRequest("/getPGOptions/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log(
            "res payment handle already present card:",
            res,
            this.stripeCardSelected
          );
          if (res.data.Status == false) {
            // this.hideLoading();
            this.$refs.sessionTimeOut.show();
          } else {
            this.paymentSecret = res.data.paymentintentid;
            let that = this;
            stripe
              .handleCardPayment(res.data.paymentintentid, {
                payment_method: this.stripeCardSelected.id
              })
              .then(function(result) {
                if (result.error && !result.hasOwnProperty("paymentIntent")) {
                  that.$refs.apiKeyfailed.show();
                  that.hideLoading();
                } else if (result.paymentIntent.status != "succeeded") {
                  alert("sorry your payment failed");
                  that.hideLoading();
                  // Display error.message in your UI.
                } else {
                  that.hideLoading();

                  that.$router.replace({
                    name: "confirmScreen",
                    params: {
                      bookingId: that.ReserveId || 0,
                      paymentId: that.PaymentId || 2
                    }
                  });
                  // The payment has succeeded. Display a success message.
                }
              });
          }
          //   handleCardPayment(this.paymentSecret, {
          // payment_method: this.stripeCards[0].id
          //       }).then(function(result) {
          //         console.log("handleCardPayment", result);
          //         if (result.error) {
          //           // Display error.message in your UI.
          //         } else {
          //           // The payment has succeeded. Display a success message.
          //         }
          //       });
          // this.handleCardPayment1();
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getSinglePaymentOptions() {
      let payload = {
        PaymentID: this.PaymentId,
        CouponCode: this.promocode,
        ReserveID: this.ReserveId,
        CategoryID: this.CategoryID,
        gogoStripe: 1
      };
      // this.showLoading();
      let that = this;
      makeRequest("/getPGOptions/", "POST", null, payload)
        .then(response => {
          that.hideLoading();
          const { error, res } = response;
          console.log("res payment2:", res);
          if (res.data.Status == false) {
            this.$refs.minimumPayment.show();
          } else {
            this.paymentSecret = res.data.paymentintentid;
            this.payNewCard();
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    update() {
      console.log("test Update");
      this.complete = this.number && this.expiry && this.cvc;

      // this.stripeCardSelected = {
      //   type: "new"
      // };
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    payNewCard() {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then(data => {
        console.log(data.token, "fsdf");

        this.createPaymentMethodMain();
        this.handleNewCardPayment();
      });
    },
    createPaymentMethodMain() {
      createPaymentMethod("card").then(data => {
        this.updatePaymentMethod(data.paymentMethod.id);

        console.log("createPaymentMethod", data);
      });
    },
    handleNewCardPayment() {
      let that = this;
      // console.log(
      //   "handleCardPayment start",
      //   this.paymentSecret,
      //   this.stripeCardSelected
      // );
      // this.showLoading();
      handleCardPayment(this.paymentSecret, {
        payment_method: this.stripeCardSelected.id
      }).then(function(result) {
        that.hideLoading();
        if (result.error) {
          console.log("handleNewCardPayment", result.error);
          if (result.error.code == "card_declined") {
            that.$refs["errorCard"].show();
            that.msgError = result.error.message;
          }

          // Display error.message in your UI.
        } else {
          that.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: that.ReserveId || 0,
              paymentId: that.PaymentId || 2
            }
          });
          // The payment has succeeded. Display a success message.
        }
      });
    },
    startStripeWithoutSavedCard: function() {
      this.timer.stop = true;
      this.getSinglePaymentOptions();

      // this.getStripeToken();
    },

    getStripeToken: function() {
      this.PaymentId = 3;

      // let payload = {
      //   PaymentID: this.PaymentId,
      //   CouponCode: this.promocode,
      //   ReserveID: this.ReserveId,
      //   CategoryID: this.CategoryID,
      //   Successurl:
      //     window.location.origin +
      //     "/confirmScreen/" +
      //     this.ReserveId +
      //     "/" +
      //     this.PaymentId +
      //     "?MovieID=" +
      //     this.showDetails.MovieID +
      //     "&CategoryID=" +
      //     this.CategoryID +
      //     "&CinemaScheduleID=" +
      //     this.CinemaScheduleID,
      //   Failurl:
      //     window.location.origin +
      //     "/failedPayment/" +
      //     this.showDetails.MovieID +
      //     "/" +
      //     this.CategoryID +
      //     "/" +
      //     this.CinemaScheduleID
      // };

      // //alert(this.ReserveId)

      // makeRequest("/pgGetToken/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     console.log("res :", res);
      //     stripe
      //       .redirectToCheckout({
      //         // Make the id field from the Checkout Session creation API response
      //         // available to this file, so you can provide it as parameter here
      //         // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      //         // "cs_test_zK9hjlUwP2t8wSKsSN08j3NwxKbl7jZZ7NeiCwRWZyJjuRaZzAneNDsa"
      //         // res.data.substr(1, res.data.length)
      //         sessionId: res.data
      //       })
      //       .then(function(result) {
      //         console.log("result :", result);
      //         // If `redirectToCheckout` fails due to a browser or network
      //         // error, display the localized error message to your customer
      //         // using `result.error.message`.
      //       });
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    onClickForgotPassword: function() {
      this.$root.$emit("bv::show::modal", "forgotpassword");
    },
    onClickLogin: function() {
      this.ShowLogin = true;
      this.ShowSignUp = false;
    },
    onClickSignUp: function() {
      this.ShowLogin = false;
      this.ShowSignUp = true;
    },
    getNowShowingData: function() {
      let payload = {
        Unique: ""
      };
      makeRequest("/GetShows/", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          this.signUpUserDetails.CountryCode =
            res.data.Default && res.data.Default.CountryISOCode;
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        if (this.timer.stop == true) {
          console.log("false");
          return;
        }

        if (
          parseInt(this.timer.seconds) == 0 &&
          parseInt(this.timer.minutes) == 0
        ) {
          // this.timer.seconds = 60;
          this.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          this.$refs.sessionTimeOut.show();
          clearTimeout(self.timerStartFunction);
          return false;
        }
        if (parseInt(this.timer.seconds) <= 0) {
          this.timer.seconds = 60;

          this.timer.minutes =
            this.timer.minutes >= 1 ? this.timer.minutes - 1 : "0";
        }
        this.timer.seconds = parseInt(this.timer.seconds) - 1;
        if (this.timer.seconds < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }
      }, 1000);
      // setInterval(() => {
      //   if (this.timer.stop == true) {
      //     return;
      //   }
      //   if (this.timer.minutes == 0 && this.timer.seconds == 0) {
      //     this.$refs.sessionTimeOut.show();

      //     // this.$root.$emit("bv::show::modal", "sessionTimeOut");
      //     //TODO Show timeout message and a redirect button
      //     this.timer.TimeoutModal = true;
      //     this.timer.minutes = 0;
      //     this.timer.seconds = 0;
      //     this.timer.stop = true;
      //   }
      //   this.timer.minutes = parseInt(this.timer.minutes) - 1;
      // }, 60000);
    },
    onCheck: function() {
      this.signUpUserDetails.termsAndConditions = !this.signUpUserDetails
        .termsAndConditions;
    },
    onUserInput({ number, isValid, country }) {
      this.userDetails.MobileNo = number;
      this.userDetails.CountryCode = country.dialCode;
      this.userDetails.CountryCode = country.dialCode;
    },
    onInput({ number, isValid, country }) {
      this.signUpUserDetails.phoneNumber = number;
      this.signUpUserDetails.CountryCode = country.dialCode;
    },
    onApplyPromocode: function() {
      let payload = {
        voucher_code: this.promocode,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isTicket: true,
        md_id: this.showDetails.md_id,
        net_amount: this.showDetails.net_amount,
        total_amount: this.showDetails.amount,
        total_ticket: this.showDetails.ticket_count,
        voucher_title: this.promocode,
        reservation_id: this.ReservationID,
        category_id:this.CategoryID
      };

      PromotionServices.VerifyVoucherCode(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.promocodeSuccesMessage = data.message;
            this.promocodeErrorMessage = "";
            this.promoApplied = true;
            let selectedVoucher = data.BoxOffice;
            this.offerData = data.Records[0];
            this.offerData["t_offer_price"] = selectedVoucher.TotalOfferPrice;
            this.offerData["oc_discount_value"] =
              selectedVoucher.TotalOfferPrice;
            this.offerData["is_on_net_amount"] =
              selectedVoucher.isOfferAppliedonNet;
            this.offerData["is_offer_for"] = "vouchers";
            this.offerData["is_offer_applied"] = true;
            this.offerData.voucher_discount = selectedVoucher.TotalOfferPrice;
            this.DiscountValue = parseFloat(selectedVoucher.TotalOfferPrice);
            this.TaxOfferValue=parseFloat(data.taxOffer)
            this.showDetails.chargeTypeArray=data.tax_calculation
          } else {
            this.promocodeSuccesMessage = "";
            this.DiscountValue = 0;
            this.promoApplied = false;
            this.promocodeErrorMessage = data.message;
          }
        })
        .catch(err => {
          console.log("Error", err);
        });
      // makeRequest("/Payment/VerifyCoupon/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.promocodeSuccesMessage = res.data.Message;
      //       this.promocodeErrorMessage = "";
      //       this.promoApplied = true;
      //       this.showDetails.TotalPrice = res.data.TicketValue.toFixed(2);
      //       this.DiscountValue = res.data.DiscountValue;
      //     } else {
      //       this.promocodeSuccesMessage = "";
      //       this.showDetails.TotalPrice = this.OGtotalAmount;
      //       this.DiscountValue = "";
      //       this.promoApplied = false;
      //       this.promocodeErrorMessage = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    calculateVoucherDiscount({ selectedVoucher, totalAmount, netAmount }) {
      let voucherDiscount = 0;

      if (selectedVoucher.voucher_is_percentage === "Y") {
        voucherDiscount =
          selectedVoucher.voucher_redeem_on_gross === "Y"
            ? (selectedVoucher.voucher_amount / 100) * totalAmount
            : selectedVoucher.voucher_redeem_on_net === "Y"
            ? (selectedVoucher.voucher_amount / 100) * netAmount
            : 0;
      } else {
        voucherDiscount = selectedVoucher.voucher_amount;
      }

      if (voucherDiscount > selectedVoucher.voucher_max_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_max_redemption_amount;
      } else if (
        voucherDiscount < selectedVoucher.voucher_min_redemption_amount
      ) {
        voucherDiscount = selectedVoucher.voucher_min_redemption_amount;
      }

      voucherDiscount = _.round(voucherDiscount, 2);

      return voucherDiscount;
    },
    onCollapse: function(params) {
      this.statusFlag.paymentActive = "active";
      this.$root.$emit("bv::toggle::collapse", params);
    },
    OTPonKeyUp: function(item, e) {
      if (this.OTP[item].length > 1) {
        this.OTP[item] = this.OTP[item][this.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        let value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    getAllGetCountryList: function() {
      MainServices.GetCountries()
        .then(response => {
          const { data } = response;
          if (data.data.length > 0) {
            this.CountryCodeList = data.data;
            this.countries = data.data;
            this.countriesCopy = data.data;
          }
        })
        .catch(err => {
          console.log("error:", err);
        });
    },
    _getAllGetCountryList: function() {
      makeRequest("/AllGetCountryList/", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.Country;
            // this.userDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
            // this.signUpUserDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onChangeCountry: function(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_id = country.country_id;
    },
    getCreateReservation() {
      // this.showLoading();
      let payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      MainServices.GetCreateShowReservationDetails(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            // console.log("response show details", response);
            console.log(data.Records[0], "data.Records[0]; >>>>>>>>>>>>>>")
            this.showDetails = data.Records[0];
            this.timer.minutes = parseInt(this.showDetails.timer_minutes);
            this.timer.seconds = parseInt(this.showDetails.timer_second);
          } else {
            this.showMessage = data.message;
            this.$refs.SeatRealeased.show();
          }
        })
        .catch(err => {
          console.log("error:", err);
        })
        .finally(() => {
          this.startTimer();
          // this.hideLoading();
        });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },

    getReservationDetails() {
      // this.showLoading();
      let payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      MainServices.GetReservationDetails(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("response", response);
            this.showDetails = data.Records[0];
            this.timer.minutes = parseInt(this.showDetails.timer_minutes);
            this.timer.seconds = parseInt(this.showDetails.timer_second);
          } else {
            this.showMessage = data.message;
            this.$refs.SeatRealeased.show();
          }
        })
        .catch(err => {
          console.log("error:", err);
        })
        .finally(() => {
          this.startTimer();
          // this.hideLoading();
        });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    hideModal() {
      this.$refs.SeatRealeased.hide();
      this.$router.go(-1);
    },
    fetchShowDetails: function() {
      let payload = {
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        ShowType: this.ShowType,
        Version: "1"
      };
      if (this.ShowType != "Private") {
        payload.BookSeats = this.BookSeats;
      }
      makeRequest("/GetShowDetails", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.showDetails = res.data;
          console.log(this.showDetails, "show details responce");
          if (res.data.hasOwnProperty("DateTime")) {
            this.checkKey = true;
          }
          let parts = this.showDetails.Date.split("-"),
            year = parseInt(parts[0], 10),
            month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
            day = parseInt(parts[2], 10);
          let date1 = new Date(year, month, day);
          this.showDetails.day = this.days[date1.getDay()].substring(0, 3);
          this.showDetails.date = date1.getDate();
          this.showDetails.month = this.months[date1.getMonth()].substring(
            0,
            3
          );
          this.showDetails.year = year;
          this.OGtotalAmount = this.showDetails.TotalPrice;
          this.showDetails.Timing = tConvert(this.showDetails.Time);
          console.log(this.showDetails.Timer);
          this.timer.minutes = parseInt(this.showDetails.Timer / 60);
          this.timer.seconds = parseInt(this.showDetails.Timer % 60);
        })
        .catch(error => {
          console.log("Error", error);
        });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    fetchUserDetails: function() {
      let token = TokenService.getToken();
      let user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code;
      }
      if (false) {
        makeRequest("/Account/GetUserProfile/", "POST", token, null)
          .then(response => {
            const { error, res } = response;
            this.userDetails = res.data;
            this.UserToken = true;
            // let phoneCode = "+" + String(this.userDetails.CountryCode);
            // this.userDetails.PhoneCode = countryArray.filter(x => {
            //   return x.dial_code === phoneCode;
            // })[0].code;
            this.errorMessage.login = "";
          })
          .catch(error => {
            console.log("Errorwewew", error);
          });
      }
    },
    validateBeforeSubmit(scope) {
      let token = TokenService.getToken();
      if (scope == "UserSignIn") {
        let payload = {
          email: this.userDetails.email,
          password: this.userDetails.password
        };
        AuthServices.Login(payload)
          .then(response => {
            const { data } = response;
            if (data.status) {
              this.ShowLogin = false;
              this.ShowSignUp = false;
              // this.tabs.collapse1 = false;
              // this.tabs.collapse2 = true;
              this.userInfo = data.Records[0];
              window.localStorage.setItem(
                "user",
                JSON.stringify(data.Records[0])
              );
              this.userLoggedIn = true;
              this.fetchUserDetails();
              this.checkPaymentMode(this.ActivePaymentModes);
              // this.$root.$emit("bv::toggle::collapse", "accordion2");
              EventBus.$emit("MakeUserLogin");
            } else {
              this.errorMessage.login = data.message;
            }
          })
          .catch(err => {
            console.log("error:", err);
          });
      }
      if (scope == "verifyUserDetails") {
        this.$validator.validateAll(scope).then(result => {
          console.log("result", result);
          if (result) {
            this.checkPaymentMode(this.ActivePaymentModes);
            this.tabs.collapse1 = false;
            this.tabs.collapse2 = true;
            this.$root.$emit("bv::toggle::collapse", "accordion2");
            // this.getReserveBookinId();
            // this.showProceedForLogin = true;
            return;
          }
        });
      } else if (scope == "verifyOtp") {
        this.confirmBooking();
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(result => {
          if (
            result &&
            this.signUpUserDetails.termsAndConditions &&
            this.signUpUserDetails.country_mob_code
          ) {
            console.log(this.signUpUserDetails, "fdsf");
            EventBus.$emit("onSingnUp", this.signUpUserDetails);
            return;
          } else {
            this.errorMessage.signUp = "Please fill in all the details";
          }
        });
      }
    },
    onSignUp() {
      EventBus.$emit("onSingnUp");
    },
    //google
    onGoogleSignInSuccess(googleUser) {
      EventBus.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.errorMessage.socialLoginError = "";
      }, 5000);
    },
    //fb
    onSignFBInSuccess(response) {
      EventBus.$emit("OnFacebookSignIn", googleUser);
    },

    onSignFBInError(error) {
      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.errorMessage.socialLoginError = "";
      }, 5000);
    },
    getReserveBookinId() {
      // this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        BookSeats: this.BookSeats,
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        Coupon: this.promocode,
        Email: this.userDetails.Email,
        Mobile: this.userDetails.MobileNo,
        CountryCode: this.userDetails.CountryCode,
        ShowType: this.ShowType,
        ReserveID: this.ReserveId,
        Version: "1"
      };
      makeRequest("/Booking/ReserveBooking", "POST", token, payload)
        .then(response => {
          const { error, res } = response;
          // this.hideLoading();
          this.showCoupon = false;
          setTimeout(function() {
            VueScrollTo.scrollTo("#PaymentShow", "1000");
          }, 1000);
          if (this.showDetails.TotalPrice != 0) {
            if (res.data.Status == true) {
              this.bookingDetails = res.data;
              this.tabs.collapse1 = false;
              this.tabs.collapse2 = true;
              this.$root.$emit("bv::toggle::collapse", "accordion2");
              this.getPaymentOptions();
            } else {
              this.errorMessage.reserveBooking =
                "Sorry the seats have been released, Please go back and select the seats again";
              this.$root.$emit("bv::toggle::collapse", "accordion2");
            }
          } else {
            if (res.data.Status == true) {
              this.FreemakePayment();
            }
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getPaymentOptions: function() {
      let payload = {
        ReserveID: this.ReserveId,
        gogoStripe: 1
      };
      let token = TokenService.getToken();

      makeRequest("/Booking/GetPaymentOptions", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          if (res.data.Status == true) {
            this.paymetOptions = res.data.Paymentoptions;
            if (this.paymetOptions.length == 1) {
              this.selectPayment(this.paymetOptions[0]);
              this.proceedStripePayment();
            }
            this.paymetOptions.map(x => {
              x.Image = x["Img-url"];
              if (x.PaymentID == 3) {
                this.stripeCards = x.savedCards.data;
              }
            });
          } else {
            this.errorMessage.reserveBooking = res.data.Message;
          }
        }
      );
    },
    onSelectPayment(payment) {
      if (payment.PaymentID == 1) {
        this.SendOTP();
      } else {
        this.errorMessage.payment = "Something Went Wrong";
      }
      if (payment.PaymentID == 3) {
        this.getSinglePaymentOptions();
      }
    },
    SendOTP: function() {
      // this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 1;
      makeRequest("/Payment/CheckWallet", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          if (res.data.Status === true) {
            // this.hideLoading();
            this.showOtpSection = true;
          } else {
            // this.hideLoading();
            this.errorMessage.payment = res.data.Message;
          }
        }
      );
    },
    getBrainTreeToken: function() {
      let self = this;
      // this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 2;
      makeRequest("/pgapi/braintree/getToken", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          // this.hideLoading();
          if (res.data.Status === true) {
            this.showBrainTreeContainer = true;
            this.showOtpSection = false;
            var clientToken = res.data.Token;
            this.paymentToken = clientToken;
            braintree.dropin.create(
              {
                authorization: clientToken,
                selector: "#dropin-container",
                threeDSecure: {
                  amount: self.showDetails.TotalPrice
                }
              },
              function(err, dropinInstance) {
                if (err) {
                  // Handle any errors that might've occurred when creating Drop-in
                  console.error(err);
                  return;
                }
                self.$refs.submitButton.addEventListener("click", function() {
                  dropinInstance.requestPaymentMethod(function(err, payload) {
                    if (err) {
                      // Handle errors in requesting payment method
                    } else {
                      self.nonce = payload.nonce;
                      self.makePayment();
                    }
                    // Send payload.nonce to your server
                  });
                });
              }
            );
          } else {
            // this.hideLoading();
            this.errorMessage.payment = res.data.Message;
          }
        }
      );
    },

    FreemakePayment: function() {
      // this.showLoading();
      let token = TokenService.getToken();

      let payload = {
        PaymentID: 0,
        ReserveID: this.ReserveId
      };
      makeRequest("/Booking/ConfirmBooking/", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          // this.hideLoading();
          if (res.data.Status) {
            this.showProceedButton = true;
            this.tabs.collapse2 = false;
            // this.tabs.collapse3 = true;
            // this.$root.$emit("bv::toggle::collapse", "accordion3");
            this.confirmDetails = res.data;

            this.$router.replace({
              name: "confirmScreen",
              params: {
                bookingId: this.confirmDetails.BookingID || 0,
                paymentId: this.PaymentId || 2
              }
            });
          } else {
            this.$router.push({
              name: "failedPayment",
              params: {
                ss_id: this.showDetails.MovieID,
                screen_id: this.CategoryID,
                md_id: this.CinemaScheduleID
              }
            });
            this.errorMessage.payment = res.data.Message;
          }
        }
      );
    },

    payNow(paymode) {

      // console.log(this.ReservationID, "Reservation >>>>>>>>>>>>")
      // this.showLoading();
      let payload = {
        isGroupRateCard: true,
        reservation_id: this.ReservationID,
        isSplitPayment: false,
        unpaid_booking: false,
        cinema_id: 1,
        payment_mode_id: 18,
        approverId: null,
        order_code: null,
        oldCustomer: true,
        customer_id: this.userInfo.cust_id,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        category_id:this.CategoryID,
        payment_mode: {
          bs_id: 1,
          bs_source: `Box Office`,
          bs_is_active: "Y",
          created_by: null,
          created_at: null,
          updated_by: 4,
          updated_at: "2020-07-16T04:20:00.000Z",
          bspm_id: 20,
          booking_source_id: 1,
          mapping_is_active: "Y",
          payment_mode_id: 18,
          pm_payment_mode: "BrainTree",
          pm_icon_url: null,
          pm_is_active: "Y",
          pm_id: 18,
          amount: 0
        },
        isLoyaltyApplied: false,
        offer: this.offerData
      };
      if (this.CategoryID == 2) {
        payload["MyCinema"] = true;
      }
      MainServices.BookSeats(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data", data);
            this.showProceedButton = true;
            this.tabs.collapse2 = false;
            this.confirmDetails = data;
            this.$router.replace({
              name: "confirmScreen",
              params: {
                show_booking_id: data.sb_booking_code,
                category_id: this.CategoryID
              }
            });
          } else {
            this.$router.push({
              name: "failedPayment"
            });
            this.errorMessage.payment = data.message;
          }
        })
        .catch(err => {
          console.log("error", err);
        })
        .finally(() => {
          // this.hideLoading();
        });
    },

    //---
    makePayment: function() {
      // this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        CountryID: "195",
        nonce: this.nonce,
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      makeRequest("/Booking/ConfirmBooking/", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          // this.hideLoading();
          if (res.data.Status) {
            this.showProceedButton = true;
            this.tabs.collapse2 = false;
            // this.tabs.collapse3 = true;
            // this.$root.$emit("bv::toggle::collapse", "accordion3");
            this.confirmDetails = res.data;
            this.$router.replace({
              name: "confirmScreen",
              params: {
                bookingId: this.confirmDetails.BookingID || 0,
                paymentId: this.PaymentId || 2
              }
            });
          } else {
            this.$router.push({
              name: "failedPayment",
              params: {
                movieId: this.showDetails.MovieID,
                categoryId: this.CategoryID,
                scheduleId: this.CinemaScheduleID
              }
            });
            this.errorMessage.payment = res.data.Message;
          }
        }
      );
    },
    confirmBooking() {
      // this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        OTP: this.OTP.toString().replace(/,/g, ""),
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      makeRequest("/Booking/ConfirmBooking/", "POST", token, payload).then(
        response => {
          const { error, res } = response;
          // this.hideLoading();
          if (res.data.Status) {
            this.showProceedButton = true;
            this.tabs.collapse2 = false;
            // this.tabs.collapse3 = true;
            // this.$root.$emit("bv::toggle::collapse", "accordion3");
            this.confirmDetails = res.data;
            this.$router.push({
              name: "confirmScreen",
              params: {
                bookingId: this.confirmDetails.BookingID || 0,
                paymentId: this.PaymentId || 2
              }
            });
          } else {
            this.$router.push({
              name: "failedPayment",
              params: {
                movieId: this.showDetails.MovieID,
                categoryId: this.CategoryID,
                scheduleId: this.CinemaScheduleID
              }
            });
            this.errorMessage.payment = res.data.Message;
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.red-line {
  background: linear-gradient(179.82deg, #e70d00 17.86%, #fa5402 126.35%);
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/*----------- Akash ----------*/
.nm-btn {
  height: 53px;
}

.gogo-text {
  color: linear-gradient(179.89deg, #e70d01 0.72%, #fa5302 216.45%);
}

.grey-text {
  color: #8d99ae;
}

.login-box input::placeholder {
  color: #8d99ae;
}

.login-box .pc-input {
  height: 56px;
  border-radius: 11px;
}

.pc-radio .custom-control-label {
  font-size: 12px;
  padding-top: 4px;
}

.fb-btn {
  width: 100%;
  height: 48px;
  background: #507cc0;
  border: 1px solid #507cc0;
  box-sizing: border-box;
  border-radius: 5px;
}

.fb-btn:hover {
  background: #507cc0;
}

.fb-btn:not(:disabled):not(.disabled):active {
  background-color: #507cc0;
}

.g-btn {
  width: 100%;
  height: 48px;
  color: black;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 5px;
}

.g-btn:hover {
  background: #ffffff;
  color: black;
}

.g-btn:not(:disabled):not(.disabled):active {
  background-color: #ffffff;
  color: black;
}

.otp-text {
  color: #fa5402 !important;
}

@media only screen and (max-width: 767px) {
  .otp-section .otp-mob {
    margin: 0 auto !important;
  }
}
.pro-circle {
  height: 150px;
  width: 150px;
}

/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/payment.vue